import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Container } from "reactstrap";
import {
  Box,
  Button,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
  Paper,
  Avatar,
  styled,
  FormControlLabel,
  Switch,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Controller, useForm } from "react-hook-form";
// import { useRouter, withRouter } from 'next/router'
// import { useAlert } from 'react-alert'
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Backdrop } from "@mui/material";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
// import { createBrowserHistory } from 'history'
// import { useHistory } from "react-router-dom";
// import { Navigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Moment from "moment";
import InputMask from "react-input-mask";
import { CancelOutlined, SaveOutlined } from "@mui/icons-material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "../Button.css";
import {
  SendRounded,
  MailOutlineRounded,
  PersonAddAltRounded,
  LockRounded,
  PersonRounded,
  EmailRounded,
  RestartAltRounded,
  VpnKeyRounded,
} from "@mui/icons-material";
import md5 from "md5";
// const history = useHistory();
const StyledInviteButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
  color: "white",
  padding: "8px 20px",
  borderRadius: "25px",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 5px 15px 2px rgba(33, 203, 243, .4)",
  },
}));

const GradientDialogTitle = styled(DialogTitle)(({ theme }) => ({
  background: "linear-gradient(45deg, #2196F3, #21CBF3)",
  color: "white",
  textAlign: "center",
  padding: "20px 24px",
  fontWeight: "bold",
  fontSize: "1.5rem",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: "16px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    "&:hover fieldset": {
      borderColor: "#2196F3",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
}));
const Patient = () => {
  // document.title = "Dashboard | Upzet - React Admin & Dashboard Template";
  document.title = "Patient | LuxBillingEHR";
  // const auth =    localStorage.getItem("Token");
  // const auth = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJqdGkiOiIwZmRiNWIxMy0wYzExLTQ4ZTQtOTdmMy1hZjhlOGNmOTJlMjgiLCJ2YWxpZCI6IjEiLCJ1c2VyRW1haWwiOiJhbGlAZ21haWwuY29tIiwicHJhY3RpY2VJZCI6IjEiLCJleHBpcnlEYXRlIjoiNy8zLzIwMjgiLCJicm93c2VyIjoiR29vZ2xlIENocm9tZSIsImFwcGxpY2F0aW9uIjoiTHV4QmlsbGluZyIsIklzQWRtaW4iOiJGYWxzZSIsIlByb3ZpZGVySWQiOiIwIiwiZXhwIjoxODQ2MDgwNTE2LCJpc3MiOiJodHRwOi8vd3d3Lkx1eEJpbGxpbmcuY29tIiwiYXVkIjoiaHR0cDovL3d3dy5MdXhCaWxsaW5nLmNvbSJ9.2Uac6a-c-IPRJFzYSvjxpRych9icwhsebjvB2lgZaOs`
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [orignalRows, setOrignalRows] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const [flastName, setFlastName] = useState("");
  const [FPatientId, setFPatientId] = useState(0);
  const [ffirstName, setFfirstName] = useState("");
  const [fdob, setFdob] = React.useState("");
  const [fphone, setFphone] = useState("");
  const [femail, setFemail] = useState("");
  const [refreshAssessment, setrefreshAssessment] = useState(false);
  const GETTING_ROWS_LABEL = "Please wait!! Your data is being loaded..";
  const [NoRowsLabel, setNoRowsLabel] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);

  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      inactive: true,
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}/Patients/addPatient`, postData, {
        headers,
      })
      .then((response) => {
        setRefresh(!refresh);
        console.log("aaa", response);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  const rights = useSelector((state) => state.login.rights);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [Password, setPassword] = useState("");
  const [UserName, setUserName] = useState("");
  const [InViteloading, setInViteloading] = useState(false);
  const handleCloseInvite = (e) => {
    setOpenInviteModal(false);
  };
  const [resetPassword, setResetPassword] = useState(false);

  const handleInviteSave = async () => {
    if (!UserName.trim() || !Password.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please fill in both username and password fields.",
        confirmButtonColor: "#2196F3",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      return;
    }

    setInViteloading(true);
    // const passwordToSend = resetPassword ? md5(Password) : Password;
    const postData = {
      id: selectedPatientId,
      userName: UserName,
      password: Password,
      email: selectedEmail,
      resetPassword: resetPassword,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientPortal/InvitePatientPortal`,
        postData,
        { headers }
      );

      const message = response?.message || response;

      if (message.toLowerCase().includes("already registered")) {
        // Show error if patient already registered
        Swal.fire({
          icon: "error",
          title: "Invitation Failed!",
          html: `<p>${message}</p>`,
          confirmButtonColor: "#F44336",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      } else if (
        message.toLowerCase().includes("invitation sent") ||
        message.toLowerCase().includes("password updated") ||
        message.toLowerCase().includes("your login credentials had been sent")
      ) {
        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Success!",
          html: `<p>${message}</p>`,
          confirmButtonColor: "#2196F3",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });

        // Reset modal
        setOpenInviteModal(false);
        setSelectedEmail("");
        setSelectedPatientId("");
        setPassword("");
        setUserName("");
        setResetPassword(false); // reset the toggle
      } else {
        // Other messages can also be handled as needed
        Swal.fire({
          icon: "info",
          title: "Notice",
          html: `<p>${message}</p>`,
          confirmButtonColor: "#2196F3",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Invitation Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    } finally {
      setInViteloading(false);
    }
  };
  const handleInvite = async (data) => {
    const postData = {
      id: data.id,
      userName: data.fullName,
      // password: data,
      email: data.emailAddress,
      resetPassword: false,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientPortal/InvitePatientPortal`,
        postData,
        { headers }
      );

      const message = response?.message || response;

     Swal.fire({
          icon: "success",
          title: "Success!",
          html: `<p>${message}</p>`,
          confirmButtonColor: "#2196F3",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
     })
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Invitation Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    } finally {
      setInViteloading(false);
    }
  };

  // Add animation styles to document head
  React.useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes bounceIn {
        from, 20%, 40%, 60%, 80%, to {
          animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
        }
        0% { opacity: 0; transform: scale3d(.3, .3, .3); }
        20% { transform: scale3d(1.1, 1.1, 1.1); }
        40% { transform: scale3d(.9, .9, .9); }
        60% { opacity: 1; transform: scale3d(1.03, 1.03, 1.03); }
        80% { transform: scale3d(.97, .97, .97); }
        to { opacity: 1; transform: scale3d(1, 1, 1); }
      }
      .animated-bounce-in {
        animation: bounceIn 0.75s;
      }
      .spinner-border {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        border: 0.2em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        animation: spinner-border .75s linear infinite;
      }
      @keyframes spinner-border {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      flex: 0.25,
      renderCell: (cellValues) => (
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            openPatientRegistration(event, cellValues.row.id);
          }}
        >{`${cellValues.row.lastName}`}</Button>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      flex: 0.25,
    },
    {
      field: "dob",
      headerName: "DOB",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      flex: 0.2,
    },
    {
      field: "address",
      headerClassName: "super-app-theme--header",
      headerName: "Address",
      // cellClassName: 'gridCell',
      flex: 0.3,
    },
    {
      field: "city",
      headerClassName: "super-app-theme--header",
      headerName: "City",
      // cellClassName: 'gridCell',
      flex: 0.2,
    },
    {
      field: "state",
      headerClassName: "super-app-theme--header",
      headerName: "State",
      flex: 0.2,
    },
    //

    {
      field: "cellPhone",
      headerClassName: "super-app-theme--header",
      headerName: "Phone #",
      flex: 0.2,
    },
    {
      field: "status",
      headerClassName: "super-app-theme--header",
      headerName: "Status",
      // cellClassName: 'gridCell',
      flex: 0.2,
    },
    {
      field: "invite",
      headerName: "Invite",
      headerClassName: "super-app-theme--header",
      flex: 0.4,
      maxWidth: 200,
      renderCell: (params) => {
        const hasEmail = !!params.row.emailAddress;
        const hasPortalUsername = !!params.row.portalUsername;

        const buttonLabel = hasPortalUsername ? "Reset Password" : "Invite";
        const buttonIcon = hasPortalUsername ? (
          <VpnKeyRounded fontSize="0.55rem" />
        ) : (
          <SendRounded fontSize="0.55rem" />
        );

        return (
          <Tooltip
            title={
              !hasEmail
                ? "Please Add Email Address"
                : hasPortalUsername
                ? "Reset Portal Password"
                : "Send Portal Invitation"
            }
            arrow
          >
            <Button
              variant="contained"
              // disabled={!hasEmail}
              onClick={() => {
                if (!hasEmail) return;
                if (hasPortalUsername) {
                  const fullName = `${params.row.firstName} ${params.row.lastName}`;
                  setSelectedPatientId(params.row.id);
                  setSelectedEmail(params.row.emailAddress);
                  setOpenInviteModal(true);
                  setUserName(fullName);
                } else {
                  const fullName = `${params.row.firstName} ${params.row.lastName}`;

                  handleInvite({
                id: params.row.id,
                fullName: fullName,
                emailAddress: params.row.emailAddress,
              });
                }
              }}
              startIcon={buttonIcon}
              sx={{
                width: "170px", // uniform width
                background: hasEmail
                  ? hasPortalUsername
                    ? "#4CAF50" // green for reset password
                    : "#2196F3" // blue for invite
                  : "rgba(0,0,0,0.12)", // faded for disabled
                color: hasEmail ? "#fff" : "#888",
                borderRadius: "20px",
                fontWeight: 300,
                fontSize: "0.55rem",
                textTransform: "none",
                boxShadow: hasEmail ? "0 2px 6px rgba(0,0,0,0.2)" : "none",
                transition: "all 0.25s ease",
                "&:hover": {
                  background: hasEmail
                    ? hasPortalUsername
                      ? "#388E3C"
                      : "#1976D2"
                    : "rgba(0,0,0,0.12)",
                  transform: hasEmail ? "translateY(-2px)" : "none",
                  boxShadow: hasEmail ? "0 4px 12px rgba(0,0,0,0.25)" : "none",
                },
              }}
            >
              {buttonLabel}
            </Button>
          </Tooltip>
        );
      },
    },

    //   {
    //     field: 'inactive',
    //     headerClassName: 'super-app-theme--header',
    //     headerName: 'Delete',
    //     sortable: true,
    //     flex: 0.15,
    //     // hide: true,
    //     // hide: Usertype == 'Admin'?false:true,

    //     renderCell: cell => (

    //       <>
    //       <DeleteIcon
    //         style={{
    //           marginRight: '5px',
    //           float: 'right',
    //           marginTop: '5px',
    //           color: 'red',
    //           cursor: 'pointer',
    //         }}
    //         color="black"
    //         onClick={() => {setDialogOpen(true)
    //           setDelbyid(cell.row.id)
    //         }}
    //       ></DeleteIcon>

    //       <Dialog
    //         open={isDialogOpen}
    //         onClose={() => setDialogOpen(false)}
    //         aria-labelledby="delete-dialog-title"
    //         BackdropComponent={Backdrop}
    //         BackdropProps={{
    //           invisible: true,
    //         }}
    //         PaperProps={{
    //           style: {
    //             marginRight: '5px',
    //           float: 'right',
    //           marginTop: '5px',
    //           color: 'red',
    //           cursor: 'pointer',
    //           },
    //         }}
    //       >
    //        <div style={{
    //   display: 'flex',
    //   flexDirection: 'column',
    //   alignItems: 'center', // Center horizontally
    //   justifyContent: 'center', // Center vertically
    //   borderRadius: '8px',
    //   width: '500px'
    // }}>

    //   <ErrorOutlineIcon style={{ fontSize: '100px', color: 'red' }} />
    //   <DialogTitle style={{ fontWeight: 'bold',color:'black',fontSize:' 1.25rem' }}>Are you sure?</DialogTitle>
    //   <h5 style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'normal',color:'#444444' }}>
    //     You won't be able to revert this!
    //   </h5>
    //   <DialogContent>
    //     <DialogContentText>

    //       <Grid style={{ marginTop: '1rem' }}>
    //         <Button onClick={() => setDialogOpen(false)} style={{ backgroundColor: '#6c7c84', color: 'white', marginBottom: '1rem' }}>No,cancel!</Button>
    //         <Button  onClick={() => handleDelete(cell)} style={{ backgroundColor: 'red', color: 'white', marginLeft: '1rem', marginBottom: '1rem',border:'1px solid #b4acec' }}>Yes,delete it!</Button>
    //       </Grid>
    //     </DialogContentText>
    //   </DialogContent>
    // </div>

    //       </Dialog>
    //     </>
    //     )
    //   }
    ...(rights?.delete_patient
      ? [
          {
            field: "inactive",
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            flex: 0.2,
            // hide: true,
            // hide: Usertype == 'Admin'?false:true,

            renderCell: (cell) => (
              <DeleteIcon
                style={{
                  marginRight: "5px",
                  float: "right",
                  marginTop: "5px",
                  color: "red",
                  cursor: "pointer",
                }}
                onClick={(cellValues) => {
                  confirmAlert({
                    message: "Do you want to delete the record.",
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    overlayClassName: "overlay-custom-class-name",

                    buttons: [
                      {
                        label: "Yes",

                        onClick: () => {
                          const postData = {
                            id: cell.row.id,
                            inactive: true,
                          };
                          axios
                            .post(
                              `${process.env.REACT_APP_API_URL}/Patients/addPatient`,
                              postData,
                              {
                                headers,
                              }
                            )
                            .then((response) => {
                              setRefresh(!refresh);
                              // setOpenNote(false)
                              // console.log('response.data: ', response.data)
                            })
                            .catch((error) => {
                              console.error("There was an error!", error);
                            });
                        },
                      },
                      {
                        label: "No",
                      },
                    ],
                  });
                }}
              ></DeleteIcon>
            ),
          },
        ]
      : []),
  ];

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
      // minHeight:'5px !important'

      // height: '35px !important',
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const openPatientRegistration = (event, id) => {
    navigate("/PatientRegistration", { state: { patientId: id } });
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Patients/getPatients`, {
        headers,
      })
      .then((response) => {
        setRows(response);
        setOrignalRows(response);
        setLoading(false);
      })

      .catch((error) => {
        console.error("There was an error!", error);
      });

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh]);
  const keyDown = (e) => {
    if (e.key === "Enter") {
      getdata(e);
    }
  };
  const onFilterClear = (event) => {
    setFlastName("");
    setFfirstName("");
    setFPatientId(0)
    setFdob("");
    setFphone("");

    setrefreshAssessment(!refreshAssessment);
  };
  const [Validate, setValidate] = useState(false);
  const onFilterSearch = (event) => {
    if (!(flastName || ffirstName || fdob || fphone || FPatientId)) {
      setValidate(true);
      return;
    }
    setrefreshAssessment(!refreshAssessment);
  };
  useEffect(() => {
    getdata();
  }, [refreshAssessment]);

  const getdata = (event) => {
    setRows(null);
    setSubmitting(true);
    // setPatientIdArr([])
    const postData = {
      lastName: flastName,
      firstName: ffirstName,
      dob: fdob,
      cellPhone: fphone,
      Id: FPatientId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        postData,
        { headers }
      )
      .then((response) => {
        if (response.length == 0) {
          setNoRowsLabel("No Record Found");
        } else {
          setRows(response);
        }
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(true);
        console.error("There was an error!", error);
      });
  };
  useEffect(() => {
    // Target the header cells and header directly and adjust their height
    const headerCells = document.querySelectorAll(".MuiDataGrid-colCell");
    const header = document.querySelector(".MuiDataGrid-header");

    if (headerCells) {
      headerCells.forEach((cell) => {
        cell.style.height = "1px";
      });
    }

    if (header) {
      header.style.height = "1px";
    }
  }, []);

  return (
    <div className="page-content">
      <Dialog
        open={openInviteModal}
        onClose={handleCloseInvite}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "14px",
            overflow: "hidden",
            maxHeight: "85vh", // HEIGHT CHOTI
            boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(45deg, #326C1D, #377562)",
            color: "white",
            textAlign: "center",
            padding: "16px 20px",
            fontWeight: "bold",
            fontSize: "1.3rem",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <PersonAddAltRounded fontSize="medium" />
            <Typography variant="h6" color={"#fff"}>
              Send Portal Invitation
            </Typography>
          </Box>
        </DialogTitle>

        {/* Body */}
        <DialogContent sx={{ padding: "20px", backgroundColor: "#f4f9f2" }}>
          {selectedEmail && (
            <Paper
              elevation={0}
              sx={{
                background: "#e9f5e4",
                padding: "9px",
                borderRadius: "10px",
                marginTop: "10px",
                borderLeft: "4px solid #326C1D",
              }}
            >
              <Box display="flex" alignItems="center" gap={1.5}>
                <EmailRounded sx={{ color: "#326C1D", fontSize: 22 }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Sending invitation to:
                  </Typography>
                  <Typography variant="body1" fontWeight="600" color="#326C1D">
                    {selectedEmail}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          )}

          {/* Avatar */}
          <Box sx={{ textAlign: "center" }}>
            <Avatar
              sx={{
                width: 70,
                height: 70,
                margin: "0 auto 12px",
                background: "linear-gradient(45deg, #326C1D, #377562)",
                boxShadow: "0 6px 14px rgba(50,108,29,0.3)",
              }}
            >
              <PersonAddAltRounded sx={{ fontSize: 34 }} />
            </Avatar>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              Enter login credentials for patient portal
            </Typography>
          </Box>

          {/* Username */}
          <TextField
            margin="dense"
            label="Username"
            fullWidth
            size="small"
            value={UserName}
            // onChange={handleInviteChange}

            InputProps={{
              readOnly: true,
              startAdornment: <PersonRounded sx={{ color: "#326C1D" }} />,
            }}
            sx={{
              marginBottom: "14px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "white",
                "&:hover fieldset": { borderColor: "#377562" },
                "&.Mui-focused fieldset": {
                  borderColor: "#326C1D",
                  borderWidth: "2px",
                },
              },
            }}
          />

          {/* Password */}
          <TextField
            margin="dense"
            label="Password"
            type="password"
            size="small"
            fullWidth
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={InViteloading}
            InputProps={{
              startAdornment: <LockRounded sx={{ color: "#326C1D" }} />,
            }}
            sx={{
              marginBottom: "14px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "white",
                "&:hover fieldset": { borderColor: "#377562" },
                "&.Mui-focused fieldset": {
                  borderColor: "#326C1D",
                  borderWidth: "2px",
                },
              },
            }}
          />

          <Paper
            elevation={0}
            sx={{
              backgroundColor: "#f6ffe8",
              borderRadius: "8px",
              border: "1px solid #d6e8c7",
              padding: "10px",
              marginTop: "10px",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <RestartAltRounded sx={{ fontSize: 25, color: "#377562" }} />
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Reset Password
                </Typography>
              </Box>

              <Switch
                checked={resetPassword}
                onClick={() => setResetPassword(!resetPassword)}
                color="success"
              />
            </Box>
            <Typography
              variant="caption"
              sx={{ color: "#555", mt: 0.5, display: "block" }}
            >
              When enabled, a password reset will be triggered for the patient.
            </Typography>
          </Paper>
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            padding: "16px 20px",
            justifyContent: "center",
            backgroundColor: "#f1f1f1",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Button
            onClick={handleCloseInvite}
            variant="outlined"
            sx={{
              borderRadius: "22px",
              padding: "8px 24px",
              textTransform: "none",
              fontWeight: 600,
              border: "2px solid #377562",
              color: "#377562",
              "&:hover": {
                backgroundColor: "#e6f2e8",
                borderColor: "#326C1D",
                color: "#326C1D",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleInviteSave}
            variant="contained"
            disabled={InViteloading}
            startIcon={InViteloading ? null : <SendRounded />}
            sx={{
              borderRadius: "22px",
              padding: "8px 24px",
              textTransform: "none",
              fontWeight: 600,
              background: InViteloading
                ? "#A5B89A"
                : "linear-gradient(45deg, #326C1D, #377562)",
              "&:hover": {
                background: InViteloading
                  ? "#A5B89A"
                  : "linear-gradient(45deg, #285316, #2f644b)",
              },
            }}
          >
            {InViteloading ? "Sending..." : "Send Invitation"}
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        {rights.add_patient && (
          <div style={{ width: "100%", marginTop: "5px", marginBottom: "0px" }}>
            <Button
              sx={{ mb: 1 }}
              className="Button"
              onClick={openPatientRegistration}
              variant="contained"
            >
              <AddOutlinedIcon
                fontSize="small"
                style={{
                  color: "white",
                  paddingRight: "4px",
                  paddingBottom: "2px",
                }}
              ></AddOutlinedIcon>
              Add New
            </Button>
          </div>
        )}

        {/* ///////////// */}
        <Grid
          container
          spacing={1}
          item
          xs={12}
          sm={12}
          xl={12}
          style={{
            width: "100%",
            marginBottom: "10px",
            border: "2px solid #326C1D",
            borderRadius: "20px",
            marginTop: "10px",
            paddingBottom: "20px",
            marginLeft: "1px",
            padding: "15px",
            // paddingLeft: '15px',
            backgroundColor: "white",
          }}
        >
            <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <Typography style={{ fontSize: "14px" }}>First Name</Typography>
            <Grid item xs={12}>
              <TextField
                onChange={(e) => setFfirstName(e.target.value)}
                value={ffirstName}
                placeholder="Please enter first name"
                onKeyDown={keyDown}
                name="firstName"
                size="small"
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>

             <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <Typography style={{ fontSize: "14px" }}>Last Name</Typography>
            <Grid item xs={12}>
              <TextField
                onChange={(e) => setFlastName(e.target.value)}
                value={flastName}
                placeholder="Please enter last name"
                name="lastName"
                size="small"
                onKeyDown={keyDown}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <Typography style={{ fontSize: "14px" }}>DOB</Typography>
            <Grid item xs={12}>
              <TextField
                onChange={(e) => setFdob(e.target.value)}
                value={fdob}
                type="date"
                placeholder="Please enter dob"
                name="dob"
                size="small"
                onKeyDown={keyDown}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>
           <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <Typography style={{ fontSize: "14px" }}>Patient ID</Typography>
            <Grid item xs={12}>
              <TextField
                onChange={(e) => setFPatientId(e.target.value)}
                value={FPatientId}
                placeholder="Please enter Id"
                name="PatientId"
                size="small"
                onKeyDown={keyDown}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <Typography style={{ fontSize: "14px" }}>Phone No</Typography>
            <Grid item xs={12}>
              <InputMask
                mask="+1 999-999-9999"
                disabled={false}
                value={fphone}
                onKeyDown={keyDown}
                // style={{ height: '30px' }}
                onChange={(e) => {
                  // setValue('ssn', e.target.value)
                  setFphone(e.target.value);
                }}
              >
                {() => (
                  <TextField
                    id="outlined-basic"
                    fullWidth
                    size="small"
                    margin="dense"
                    placeholder="Enter Phone NO"
                  />
                )}
              </InputMask>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {Validate && (
              <p style={{ color: "red", fontSize: "14px" }}>
                Please select a Data For Patient.
              </p>
            )}
          </Grid>

          <Grid container>
            <Grid item xs={9} sm={9} xl={9}></Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Button
                className="Button"
                onClick={onFilterSearch}
                variant="gradient"
                style={{
                  marginTop: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#FCBE13',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <SearchOutlinedIcon
                  fontSize="medium"
                  style={{ color: "white", paddingBottom: "1px" }}
                ></SearchOutlinedIcon>
                Search
              </Button>
              <Button
                className="Button"
                onClick={onFilterClear}
                variant="gradient"
                style={{
                  marginTop: "10px",
                  marginLeft: "auto",
                  float: "right",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#FCBE13',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CleaningServicesOutlinedIcon
                  fontSize="medium"
                  style={{ color: "white", paddingRight: "5px" }}
                ></CleaningServicesOutlinedIcon>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/* /////////// */}
        {/* <Grid container>
              <Grid item xs={1.5} style={{ width: "300px" }}>
                  <Typography style={{marginTop:'4px',fontWeight:"bold", marginTop:'8px'}}>Patient Search</Typography>
                </Grid>
              <Grid item xs={6}>
                <Box mt={"5px"} mb={0}>
                  <input
                 
                    placeholder="Search here..."
                    onChange={(evt) => {
                      setRows(orignalRows);
                      let keyword = evt.target.value;
                      if (keyword == "") {
                        return;
                      }
                      keyword = keyword.toLowerCase();
                      let filtered = rows.filter((entry) =>
                        Object.values(entry).some(
                          (val) =>
                            typeof val === "string" &&
                            val != null &&
                            val != "" &&
                            val != "null" &&
                            val.toLowerCase().includes(keyword)
                        )
                      );
                      setRows(filtered);
                    }}
                    spacing={0}
                    item
                    xs={12}
                    sm={12}
                    xl={12}
                    style={{
                      width: "100%",
                      height:'30px',
                      marginBottom: "0px",
                      border: "1px solid rgba(12, 152, 236, 0.637)",
                      borderRadius: "20px",
                      marginTop: "0px",
                      paddingBottom: "0px",
                      marginLeft: "0px",
                      padding: "12px",
                      paddingLeft: "18px",
                      paddingRight: "5px",
                      marginRight: "5px",
                      // paddingLeft: '15px',
                      backgroundColor: "white",
                    }}
                  />
                </Box>
              </Grid>
              </Grid> */}

        <Box mb={3} marginTop={2}>
          {isLoading ? (
            <div style={{ margin: "5rem", textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <div style={{ height: 400, width: "100%" }}>
              {rows === null || rows.length === 0 ? (
                <Typography>{NoRowsLabel || GETTING_ROWS_LABEL}</Typography>
              ) : (
                <DataGrid
                  rows={rows.filter((row) => row.status === "Active")}
                  // rowHeight={28}
                  columns={columns}
                  classes={gridClasses}
                  sx={gridRowStyle}
                  pagination
                  pageSizeOptions={[25]}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 25, page: 0 },
                    },
                  }}
                  rowHeight={30}
                />
              )}
            </div>
          )}
        </Box>
      </Container>
    </div>
  );
};
export default Patient;
